export default "__VITE_ASSET__99dbfaf4__"